App.factory('Form', ['restmod', restmod => {
  return restmod.model('/forms')
}])
